import React, { useEffect, useRef } from "react";

const BnbRain = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const coins = [];
        const coinImage = new Image();
        coinImage.src = "https://cryptologos.cc/logos/binance-coin-bnb-logo.png"; // Use BNB logo URL

        class Coin {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * -canvas.height;
                this.size = Math.random() * 30 + 20;
                this.speed = Math.random() * 3 + 2;
            }

            draw() {
                ctx.drawImage(coinImage, this.x, this.y, this.size, this.size);
            }

            update() {
                this.y += this.speed;
                if (this.y > canvas.height) {
                    this.y = Math.random() * -canvas.height;
                    this.x = Math.random() * canvas.width;
                }
            }
        }

        function init() {
            for (let i = 0; i < 15; i++) {
                coins.push(new Coin());
            }
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            coins.forEach((coin) => {
                coin.update();
                coin.draw();
            });
            requestAnimationFrame(animate);
        }

        init();
        animate();

        const handleResize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return <canvas ref={canvasRef} className="absolute top-0 left-0 w-full h-full pointer-events-none" />;
};

export default BnbRain;